// main landing screen
import { useState } from "react";
import { useHistory } from "react-router-dom";

import ContentFormatXW from "../content/webz/content-format-xw";

import WebbDividerMedium from "../content/webx/webb-divider-md";
import WebbDividerSmall from "../content/webx/webb-divider-sm";

import MainIntroModule from "../content/main/main-view-intro";
import MainBinsModule from "../content/main/main-view-bins";
import MainArticlesModule from "../content/main/main-view-articles";
import MainActionsModule from "../content/main/main-view-actions";

export default function Main () {
  
  const history = useHistory();

  return(
    <ContentFormatXW 
      name = 'Home'
      home = {`/`}
      link = {`/`}
      head = 'medium'
      form = 'medium'
      avtr = { <> </> }
      data = {
        <>
          
          <WebbDividerMedium />
          <WebbDividerMedium />
          <MainIntroModule />

          <WebbDividerMedium />
          <WebbDividerMedium />
          <WebbDividerMedium />
          <div className="border-bottom"></div>
          <WebbDividerMedium />
          <WebbDividerMedium />
          <WebbDividerMedium />


          <MainBinsModule />
          <WebbDividerMedium />
          <WebbDividerMedium />

          <MainArticlesModule />
          <WebbDividerMedium />
          <WebbDividerMedium />

          <MainActionsModule />

          <WebbDividerMedium />
          <WebbDividerMedium />
          <WebbDividerMedium />


        </>
      } 
    />
  )
}